export type GDPRFiles = Readonly<{
    folder: string
    files: Array<GDPRFile>
}>

export type GDPRFile = Readonly<{
    title: string
    url: string
    icon: {
        url?: string
        color?: string
        spec: string
        type: IconType
    }
}>

export type UsersByDomainReportDetails = Readonly<{
    verifiedDomains: Array<string>
    startDate: string
    endDate: string
    reportTime: string
}>

export type UserByDomain = Readonly<{
    initials: string
    givenName: string
    surname: string
    email: string
    localePhone: string
    mobileNumber: string
    username: string
    userGroup: {
        name: string
    }
    company: {
        name: string
    }
    userType: GDPRFilterUserTypes
    roles: Array<string>
    history: {
        created: UserByDomainHistory
        updated: UserByDomainHistory
        deleted: UserByDomainHistory
    }
}>

export type UserByDomainHistory = Readonly<{
    timestamp: string
    author: string
}>

export enum IconType {
    FONT_AWESOME = "FONT_AWESOME",
    IMAGE_URL = "IMAGE_URL",
}

export enum GDPRUserDeletionPeriod {
    DAYS_7 = "DAYS_7",
    DAYS_30 = "DAYS_30",
    DAYS_90 = "DAYS_90",
    DAYS_180 = "DAYS_180",
}

export enum GDPRFilterUserTypes {
    ADMINISTRATOR = "ADMINISTRATOR",
    USER = "USER",
}
